<template>
    <a-card class="project-info" :bordered="false">
      <a-row>
        <a-col :span="4" >
          <a-anchor style="margin-left: 20px" class="menu-panel" :affix="true" @click="handleClickAnchor">
            <a-anchor-link class="anchor-link" href="info1" title="项目状态" />
            <a-anchor-link class="anchor-link" href="info2" title="项目简介" />
            <a-anchor-link class="anchor-link" href="info3" title="项目设计方案配置" />
            <a-anchor-link class="anchor-link" href="info4" title="纳入排除标准" />
            <a-anchor-link class="anchor-link" href="info5" title="文档资料" />
            <!--<a-anchor-link class="anchor-link" href="info6" title="微信端配置" />-->
            <a-anchor-link class="anchor-link" href="info7" title="受试者固定属性配置" />
            <a-anchor-link class="anchor-link" href="info8" title="受试者自定义属性配置" />
            <a-anchor-link class="anchor-link" href="info9" title="关注指标" />
            <a-anchor-link class="anchor-link" href="info10" title="录音提醒" />
            <a-anchor-link class="anchor-link" href="info11" title="趋势指标配置" />
            <a-anchor-link class="anchor-link" href="info12" title="工作量统计元素配置" />
            <a-anchor-link class="anchor-link" href="info13" title="其他配置" />
          </a-anchor>
        </a-col>
        <a-col :span="20" class="info-setting">
          <div id="info1" class="panel">
            <div class="title">
              项目状态
            </div>
            <div class="info">
              当前项目状态：<project-status :status="project.status"></project-status>
              <a-button type="primary" class="title-btn" v-if="project.status==='1'"  v-has="'project:status:1'" @click="changeStatus('2','应用项目')">应用项目</a-button>
              <a-button type="primary" class="title-btn" v-if="project.status==='2'"  v-has="'project:status:2'" @click="changeStatus('3','启动项目')">启动项目</a-button>
              <a-button type="danger" class="title-btn" v-if="project.status==='3'"   v-has="'project:status:3'" @click="changeStatus('4','暂停项目')">暂停项目</a-button>
              <a-button type="primary" class="title-btn" v-if=" project.status==='4'" v-has="'project:status:4'" @click="changeStatus('3','恢复项目')">恢复项目</a-button>
              <!--终止项目暂时不用-->
              <!--<a-button type="danger" class="title-btn" v-if="project.status==='3' || project.status==='4'" @click="changeStatus('5','终止项目')">终止项目</a-button>-->
              <a-button type="danger" class="title-btn" v-if="project.status==='3' || project.status==='4' || project.status==='5'" v-has="'project:status:5'" @click="changeStatus('2','重置项目')">重置项目</a-button>
            </div>
          </div>
          <div id="info2" class="panel">
            <a-row>
              <a-col :span="18" class="title">
                  项目简介
              </a-col>
              <a-col :span="6" class="title-btn-panel">
                  <a-button v-if="!intro.edit" class="title-btn" type="primary" @click="introEdit">编辑</a-button>
                <template v-else>
                  <a-button type="primary" class="title-btn" @click="introCancel">取消</a-button>
                  <a-button type="primary" class="title-btn" @click="introSubmit">保存</a-button>
                </template>
              </a-col>
            </a-row>
            <div class="info">
              <div class="base-info-item">
                项目简介：
                <label v-if="!intro.edit">
                  {{project.intro}}
                </label>
                <a-textarea v-else placeholder="请输入" :rows="2" v-model="intro.intro" />
              </div>
              <div class="base-info-item">
                项目申办人：
                <label v-if="!intro.edit">
                  {{project.projectCreateUserName}}
                </label>
                  <a-input v-else v-model="project.projectCreateUserName" readOnly class="input"></a-input>
              </div>
              <div class="base-info-item">
                项目联系人：
                <label v-if="!intro.edit">
                  {{project.contactName}}
                </label>
                <a-select  v-else v-model="intro.contact" class="input">
                  <a-select-option :value="userInfo.userId" v-for="userInfo in userList" :key="userInfo.userId">
                    {{userInfo.realname}}
                  </a-select-option>
                </a-select>
              </div>
              <div class="base-info-item">
                联系电话：
                <label v-if="!intro.edit">
                  {{project.contactPhone}}
                </label>
                <a-input v-else v-model="intro.contactPhone" class="input"></a-input>
              </div>
              <div class="base-info-item">
                预计结束时间：
                <label v-if="!intro.edit">
                  {{project.planEndDate}}
                </label>
                <a-date-picker
                  v-else
                  class="input"
                  placeholder="请选择"
                  valueFormat="YYYY-MM-DD"
                  v-model="intro.planEndDate"/>
              </div>
            </div>
          </div>
          <div id="info3" class="panel">
            <a-row>
              <a-col :span="18" class="title">
                项目设计方案配置
              </a-col>
              <a-col :span="6" class="title-btn-panel">
                <a-button v-if="!design.edit" class="title-btn" type="primary" @click="designEdit">编辑</a-button>
                <template v-else>
                  <a-button type="primary" class="title-btn" @click="designCancel">取消</a-button>
                  <a-button type="primary" class="title-btn" @click="designSubmit">保存</a-button>
                </template>
              </a-col>
            </a-row>
            <div class="info">
              <div class="base-info-item">
                研究类型：
                <label v-if="!design.edit">{{project.researchType}}</label>
                <a-input v-else v-model="design.researchType"  class="input"></a-input>
              </div >
              <div class="base-info-item">
                设计方案：
                <label v-if="!design.edit">{{project.designScheme}}</label>
                <a-input v-else v-model="design.designScheme"  class="input"></a-input>
              </div>
              <div class="base-info-item">
                设计模式：
                <label v-if="!design.edit">{{project.designModal}}</label>
                <a-input v-else v-model="design.designModal"  class="input"></a-input>
              </div>
              <div class="base-info-item">
                总样本量：
                <label v-if="!design.edit">{{project.sampleCount}}</label>
                <a-input-number v-else v-model="design.sampleCount" :min="0" :precision="0" class="input"/>
              </div>
              <div class="base-info-item">
                  <div>
                    分组信息：
                  </div>
                <group-list class="tb-panel" :project-id="projectId"></group-list>
              </div>
            </div>
          </div>
          <div id="info4" class="panel">
            <a-row >
              <a-col :span="18" class="title">
                纳入排除标准
              </a-col>
              <a-col :span="6" class="title-btn">
                <!--<a-button  type="primary">编辑</a-button>-->
                <!--<template >-->
                <!--<a-button type="primary">取消</a-button>-->
                <!--<a-button type="primary">保存</a-button>-->
                <!--</template>-->
              </a-col>
            </a-row>
            <filtrate :projectId="projectId"  style="margin-left: 20px"></filtrate>
          </div>
          <div id="info5" class="panel">
            <file-list></file-list>
          </div>
          <!--<div id="info6" class="panel">-->
            <!--<a-row>-->
              <!--<a-col :span="18" class="title">-->
                <!--微信端配置-->
              <!--</a-col>-->
              <!--<a-col :span="6" class="title-btn">-->
                <!--&lt;!&ndash;<a-button  type="primary">编辑</a-button>&ndash;&gt;-->
                <!--&lt;!&ndash;<template >&ndash;&gt;-->
                <!--&lt;!&ndash;<a-button type="primary">取消</a-button>&ndash;&gt;-->
                <!--&lt;!&ndash;<a-button type="primary">保存</a-button>&ndash;&gt;-->
                <!--&lt;!&ndash;</template>&ndash;&gt;-->
              <!--</a-col>-->
            <!--</a-row>-->
            <!--<div class="info">-->
              <!--尚未开启微信的服务,如需启动,请联系工程师!-->
            <!--</div>-->
          <!--</div>-->
          <div id="info7" class="panel">
            <patient-base-field-set ></patient-base-field-set>
          </div>
          <div id="info8" class="panel">
            <patient-field-set></patient-field-set>
          </div>
          <div id="info9" class="panel">
            <concern-list></concern-list>
          </div>
          <div id="info10" class="panel">
            <div class="title">
              录音提醒
            </div>
            <div class="info">
              录音提醒：<a-switch v-model="recordingBl" @change="onSwitchChange" />
            </div>
          </div>
          <div id="info11" class="panel">
            <tendency-list></tendency-list>
          </div>
          <div id="info12" class="panel">
            <project-statistic-workload-config-list></project-statistic-workload-config-list>
          </div>
          <div id="info10" class="panel" v-has="'other:config'">
            <div class="title">
              其他配置
            </div>
            <div class="info">
              查看报告：<a-switch v-model="reportingBl" @change="onSwitchChangeReporting" />
            </div>
            <div class="info">
              RCT配置：<a-switch v-model="rctBl" @change="onSwitchChangeRCT" />
            </div>
          </div>
          <div id="info10" class="panel" v-has="'rct:config'" v-if="rctBl">
            <div class="title">
              RCT配置
            </div>
            <div class="info">
              <label >  入组人数：{{ rctConfig.number }}人</label><br>
              <label >  入组模型：{{ rctConfig.mode }}</label><br>
              <label >  {{rctConfig.group[0].remark}}</label><br>
              <label >  {{rctConfig.group[1].remark}}</label><br>
            </div>
          </div>
          <div id="info13" class="panel">
            <div>测评结果引导语：
              <a-button type="primary" @click="resultTipEdit" v-if="!resultTip.edit">编辑</a-button>
              <a-button type="primary" @click="resultTipSave"  v-else>保存</a-button>
              <label style="margin-left: 20px;font-size: 12px;color: rgba(0,0,0,0.5);">配置了“测评结果引导语”视为开启短信推送测评结果。</label>
            </div>
            <div>
              <div style="white-space: pre-wrap"  v-if="!resultTip.edit" v-html="project.resultTip || ''">

              </div>
              <a-textarea :rows="4" v-else v-model="resultTip.resultTip" :min="0" :precision="0" />
            </div>
            <div style="margin-top: 20px">问卷星地址：
              <a-button type="primary" @click="wjxUrlEdit" v-if="!wjxUrl.edit">编辑</a-button>
              <a-button type="primary" @click="wjxUrlSave"  v-else>保存</a-button>
            </div>
            <div>
              <div style="white-space: pre-wrap"  v-if="!wjxUrl.edit" v-html="project.wjxUrl || ''">

              </div>
              <a-textarea :rows="2" v-else v-model="wjxUrl.wjxUrl" :min="0" :precision="0" />
            </div>
          </div>
        </a-col>
      </a-row>
    </a-card>
</template>

<script>
  import FileList from './info/FileList'
  import PatientFieldSet from './info/PatientFieldSet'
  import PatientBaseFieldSet from './info/PatientBaseFieldSet'
  import ConcernList from './info/ConcernList'
  import TendencyList from './info/TendencyList'
  import GroupList from './info/GroupList'
  import { getAction ,postAction,putAction} from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  import ProjectStatus from '@/views/management/project/projectList/ProjectStatus'
  import Filtrate from '../components/Filtrate'
  import ProjectStatisticWorkloadConfigList from './info/ProjectStatisticWorkloadConfigList'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  export default {
    name: 'Info',
    components: { ATextarea, ProjectStatisticWorkloadConfigList, Filtrate, ProjectStatus, GroupList, TendencyList, ConcernList, PatientBaseFieldSet, PatientFieldSet, FileList },
    data(){
      return {
        rctConfig:{"number": "2300","mode": "按照1:1，动态区组随机2、4、6、8的方式将患者随机分入实验组（A）和对照组（B）","role": "1",
        "group": [{"remark": "实验组（A）: 0.4 mg/kg艾司氯胺酮稀释于20ml生理盐水（艾司氯胺酮组）"}, 
                  {"remark": "对照组（B）: 0.9% 20ml生理盐水将以30毫升/小时的速度静脉注射40分钟"}]
      },
        status:'2',
        recordingBl:false,
        reportingBl:false,
        rctBl:false,
        project:{},
        intro:{

        },
        projectId:'',
        design:{},
        userList:[],
        resultTip:{
          edit:false,

        },

        wjxUrl :{
          edit:false,
          wjxUrl: ''
        },
        voicePassRate :{
          edit:false,
          value: ''
        }
      }
    },
     watch: {
      $route(){
        // console.log("watch")
        this.initData()
      }
    },
    mounted(){
      // console.log("mounted")
      this.initData()
    },
    methods:{
      initData(){
        this.projectId = Vue.ls.get(CACHE_PROJECT_ID)
        // console.log("projectId:" + this.projectId)
        getAction('/management/project/getInfoById',{id:this.projectId}).then(res=>{
          if(res.success){
            this.project = res.result
            this.recordingBl = this.project.recording==='1'
            this.reportingBl=this.project.reporting==='1'
            this.rctBl=this.project.rctConfig==='1'
          }
        })
        getAction('/project/projectUser/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.userList = res.result
          }
        })
      },
      wjxUrlEdit(){
        this.wjxUrl = {
          edit:true,
          wjxUrl: this.project.wjxUrl
        }
      },
      wjxUrlSave(){
        this.project.wjxUrl = this.wjxUrl.wjxUrl
        putAction('/management/project/edit',this.project).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.wjxUrl.edit = false
          }
        })
      },
      resultTipEdit(){
        this.resultTip = {
          edit:true,
          resultTip: this.project.resultTip
        }
      },
      resultTipSave(){
        this.project.resultTip = this.resultTip.resultTip
        putAction('/management/project/edit',this.project).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.resultTip.edit = false
          }
        })
      },
      voicePassRateEdit(){
        this.voicePassRate = {
          edit:true,
          value: this.project.voicePassRate
        }
      },
      voicePassRateSave(){
        this.project.voicePassRate = this.voicePassRate.value
        putAction('/management/project/edit',this.project).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.voicePassRate.edit = false
          }
        })
      },
      changeStatus(status,operation){
        const that = this
        that.$confirm({
          title: `确认${operation}？`,
          content: `是否${operation}？`,
          onOk: function () {
            that.loading = true;
            postAction('/management/project/updateStatus',{projectId:that.projectId,status:status,operation:operation}).then(res=>{
              if(res.success){
                that.project.status = status
              }
            })
          }
        });

      },
      handleClickAnchor(e, link) {
        e.preventDefault();
        const srcolls = document.getElementById(link.href);
        if(srcolls){
          srcolls.scrollIntoView({block: 'start', behavior: 'smooth'});
        }
      },
      designEdit(){
        this.design = Object.assign({edit:true},this.project)
        this.design.edit=true
      },
      designCancel(){
        this.design.edit = false
      },
      designSubmit(){
        if(!this.design.researchType){
          return this.$message.warning('研究类型不能为空')
        }
        // if(!this.design.designScheme){
        //   return this.$message.warning('设计方案不能为空')
        // }
        if(!this.design.sampleCount){
          return this.$message.warning('总样本量不能为空')
        }
        this.project = Object.assign(this.project,this.design)
        putAction('/management/project/edit',this.project).then(res=>{
          if(res.success){
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.designCancel()
        })
      },

      introEdit(){
        this.intro = Object.assign({edit:true},this.project)
        this.intro.edit=true
      },
      introCancel(){
        this.intro.edit = false
      },
      introSubmit(){
        this.project = Object.assign(this.project,this.intro)
        this.userList.forEach(userInfo=>{
          if(userInfo.userId===this.project.contact){
            this.project.contactName = userInfo.realname

          }
        })
        putAction('/management/project/edit',this.project).then(res=>{
          if(res.success){
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.introCancel()
        })
      },
      onSwitchChange(checked){
        const recording = checked?'1':'0'
        this.project.recording = recording
        putAction('/management/project/editRecording',{id:this.projectId,recording:recording}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
          }
        })
      },
      onSwitchChangeReporting(checked){
        const reporting = checked?'1':'0'
        this.project.reporting = reporting
        putAction('/management/project/editReporting',{id:this.projectId,reporting:reporting}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
          }
        })
      },
      onSwitchChangeRCT(checked){
        const rctConfig = checked?'1':'0'
        this.project.rctConfig = rctConfig
        putAction('/management/project/editRctConfig',{id:this.projectId,rctConfig:rctConfig}).then(res=>{
          if(res.success){
            this.$message.success(res.message)
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .project-info{
    .anchor-link{
      margin-bottom: 30px;
      font-size: 16px;
    }
    .info-setting{
      height: calc(100vh - 180px);
      overflow-y: auto;
      border-left: 1px solid rgba(0,0,0,0.2);
    }
    .menu-panel{
      /*height: calc(100vh - 180px);*/
    }
    .input{
      width: 300px;
    }
    .panel{
      padding-left: 30px;
      padding-right: 30px;
      margin-bottom: 30px;
      .title{
        font-size: 16px;
        margin-bottom: 10px;
        padding-left: 10px;
        border-left: 5px solid @primary-color;
      }
      .title-btn-panel{
        text-align: right;
      }
      .title-btn{
        margin-left: 10px;
      }
      .info{
        margin-left: 25px;
      }
      .base-info-item{
        margin-bottom: 10px;
      }
      .tb-panel{
        width: 800px;
      }

    }

  }
</style>
<style lang="less">
  .project-info{
    .ant-anchor-wrapper{
      max-height: none !important;
    }

  }
</style>